<template>
  <div class="check-in">
    <v-container>
      <v-slide-y-transition mode="out-in">
        <v-layout column>
          <v-slide-y-transition mode="out-in" appear tag="div">
            <v-flex v-if="loading" xs10 offset-xs1 mt-5 class="loading text-xs-center primary--text">
              <h1 class="display-3">Loading</h1>
              <h1 class="display-3"><i class="fas fa-spinner fa-pulse"></i></h1>
            </v-flex>
            <CheckInForm
              v-else-if="showForm"
              :buy="buy"
              :driver-license="driver_license"
              working-text="Checking in ..."
              @submit-form="handleSubmitForm"
              key="form"
            />
            <CheckInTerms
              :buy="buy"
              :driver-license="driver_license"
              :working="termsWorking"
              v-else-if="showTerms"
              @submit-terms="handleSubmitTerms"
              @input-signature="handleInputSignature"
              key="terms"
            />
            <CheckInStatus
              v-else-if="showStatus"
              :buy="buy"
              key="status"
            />
          </v-slide-y-transition>
        </v-layout>
      </v-slide-y-transition>
    </v-container>
    <CheckInConfirmationCode
      :buy="buy"
      :dialog="dialog"
      @confirm="handleCodeConfirmed"
      @show-error="showSnackbar"
      @cancel="handleDialogCancel"
    />
    <v-snackbar v-model="snackbar">{{ snackbarMessage }}</v-snackbar>
  </div>
</template>

<script>
import CheckInForm from './CheckInForm'
import CheckInConfirmationCode from './CheckInConfirmationCode'
import CheckInTerms from './CheckInTerms'
import CheckInStatus from './CheckInStatus'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  props: {
    checkin_key: String,
    store_number: String
  },
  data () {
    return {
      driver_license: {
        number: '',
        state: '',
        expire_date: ''
      },
      railsForm: [],
      buyChannel: null,
      termsWorking: false,
      formSubmitted: false,
      loading: true,
      confirmed: false,
      dialog: false,
      snackbar: false,
      snackbarMessage: '',
      lastNumber: ''
    }
  },
  computed: {
    ...mapState(['buy', 'checkinKey']),
    ...mapGetters(['buyCheckinKey']),
    showForm () {
      return (
        !this.buy.signature_file_name &&
        !this.formSubmitted &&
        !this.showStatus
      )
    },
    showConfirmation () {
      return (
        !this.buyLoaded &&
        !this.confirmed
      )
    },
    showTerms () {
      if (!this.buyLoaded) {
        return (
          !this.buy.signature_file_name &&
          this.formSubmitted &&
          this.confirmed &&
          !this.showStatus
        )
      }
      return (
        !this.buy.signature_file_name &&
        this.formSubmitted &&
        !this.showStatus
      )
    },
    showStatus () {
      let ret = false
      if (this.buy.signature_file_name) {
        ret = true
      }
      return ret
    },
    buyLoaded () {
      return !!this.buy.id
    },
    customerFirstName () {
      return this.buy.customer.full_name.trim().split(' ')[0]
    },
    customerLastName () {
      let split = this.buy.customer.full_name.trim().split(' ')
      return split.slice(1).join(' ')
    },
    customerLoyalty () {
      return !!this.buy.customer.loyalty
    },
    customer () {
      return this.buy.customer
    },
    buyUpdatePayload () {
      return {
        key: this.buy.checkin_key,
        buy: {
          signature: this.buy.signature
        },
        customer: {
          id: this.buy.customer.id,
          first_name: this.customerFirstName,
          last_name: this.customerLastName,
          email: this.buy.customer.email,
          loyalty: this.customerLoyalty
        },
        driver_license: {
          full_name: this.customer.full_name,
          number: this.driver_license.number,
          state: this.driver_license.state,
          expire_date: this.driver_license.expire_date
        }
      }
    }
  },
  mounted () {
    if (this.checkinKey) this.loadBuyAndStore()
    if (this.store_number) this.loadStore()
  },
  methods: {
    ...mapMutations(
      [
        'setBuy',
        'setSignature'
      ]
    ),
    ...mapActions(
      [
        'getBuyAndStoreFromKey',
        'createConfirmationCode',
        'getStoreFromNumber'
      ]
    ),
    loadBuyAndStore () {
      if (this.checkinKey) {
        this.getBuyAndStoreFromKey(this.checkinKey)
          .then((response) => {
          })
          .catch((error) => {
            console.log(error)
            if (error && error.response && error.response.status === 404) this.$router.push('/')
            throw error
          })
          .then(() => { this.loading = false })
      } else {
        this.loading = false
      }
    },
    loadStore () {
      if (this.store_number) {
        this.getStoreFromNumber(this.store_number)
          .then(() => {
            this.loading = false
          })
      } else {
        this.loading = false
      }
    },
    parseJSON: function () {
      let buy = JSON.parse(this.buyJson)
      delete buy.container_num
      this.buy = buy
    },
    handleSubmitForm () {
      this.formSubmitted = true
      if (this.showConfirmation) {
        this.dialog = true
      }
    },
    handleSubmitTerms () {
      // Deprecated - this never happens
      this.submitBuy()
    },
    handleInputSignature (signature) {
      // this.buy.signature = signature
      this.setSignature(signature)
    },
    handleCodeConfirmed () {
      this.confirmed = true
      this.dialog = false
    },
    handleDialogCancel () {
      this.dialog = false
      this.formSubmitted = false
    },
    getBuyChannel () {
      const key = (this.buyCheckinKey
        ? this.buyCheckinKey
        : this.checkinKey
      )

      let channel
      if (key) {
        channel = this.$pusher.channel(`buy-channel-${key}`)
        if (!channel) {
          channel = this.$pusher.subscribe(`buy-channel-${key}`)
        }
      }
      return channel
    },
    bindUpdate (channel) {
      channel.unbind('update')
      channel.bind('update', (data) => {
        this.setBuy(data)
      })
    },
    async subscribeToBuyChannel () {
      const channel = await this.getBuyChannel()
      this.bindUpdate(channel)
    },
    submitBuy () {
      // Deprecated - this never happens
      this.termsWorking = true
      this.$http.patch(`${this.buy.checkin_key}.json`, this.buyUpdatePayload)
        .then((response) => {
          // good stuffs
        })
        .catch((response) => {
          // bad stuffs
        })
        .then(() => {
          this.termsWorking = false
        })
    },
    parseName () {
      this.buy.customer.full_name.trim()
      let split = this.buy.customer.full_name.split(' ')
      let first = split[0]
      let last = split.slice(1)
      return {first: first, last: last}
    },
    showSnackbar (msg) {
      this.snackbarMessage = msg
      this.snackbar = true
    }
  },
  created () {
    this.subscribeToBuyChannel()
  },
  watch: {
    dialog (v) {
      if (!!v && this.showConfirmation) {
        if (this.buy.customer.phone_number !== this.lastNumber) {
          this.createConfirmationCode(this.buy.customer.phone_number)
          this.lastNumber = this.buy.customer.phone_number
        }
      }
    },
    buyCheckinKey (v) {
      if (v) {
        this.subscribeToBuyChannel()
      }
    }
  },
  components: { CheckInForm, CheckInConfirmationCode, CheckInTerms, CheckInStatus }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CheckIn.vue